export const localBanner = {
    HOME: 1,
    VAGA_BUSCA: 2,
    VAGA_DETALHES: 3,
    PAINEL: 4,
    EMPLOYER_PAGE: 5,
};

export const banner = {
    async renderizar(containerId, local, exibirMobile = true) {
        const container = document.getElementById(containerId);        
        
        if (!container) {
            console.error('[banner]: não foi encontrado nenhuma div com o id especificado para renderizar o banner!');
            return;
        }

        try {
            const banner = await this._buscarBanner(local);
            if (banner.sucesso && banner) {
                this._renderizarHTML(container, banner, local, exibirMobile);
            } 
        } catch (error) {
            console.error('Erro ao carregar banner:', error);
        }
    },

    async _buscarBanner(local) {
        try {
            const response = await fetch(`/${CULTURE_EMPREGARE}/Home/GetBanner?local=${local}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            return await response.json();
        } catch (error) {
            console.error('Erro ao buscar banner:', error);
            return { sucesso: false };
        }
    },

    _renderizarHTML(container, banner, local, exibirMobile) {
        const redirectUrl = `/${CULTURE_EMPREGARE}/Home/RedirectBanner?id=${banner.ID}&local=${local}`;

        //const botaoFecharHTML = botaoFechar
        //    ? `
        //    <button class="btn-close position-absolute top-0 end-0 m-2" aria-label="Fechar" 
        //            style="background-color: rgba(0,0,0,0.5); color: white;">
        //    </button>`
        //    : '';

        const classesConteudo = `${exibirMobile ? `d-flex` : `d-none d-md-flex`} justify-content-center`;

        // As URLs vem prontas do servidor (UrlPadrao.BannerMidia): montar aqui com o host fixo
        // quebrava a imagem em DEV.
        const pictureHTML = `
                <picture class="col-12 text-center">
                    <source media="(max-width: 767px)"
                            srcset="${banner.UrlMobile}">
                    <img src="${banner.UrlDesktop}"
                         alt="${banner.Titulo}"
                         class="img-fluid rounded-2"/>
                </picture>`;

        // Banner sem URL cadastrada nao pode virar link: o RedirectBanner contabilizaria um clique e
        // mandaria o usuario para a home.
        const conteudoHTML = banner.PossuiLink
            ? `<a href="${redirectUrl}" target="_blank" class="${classesConteudo}">${pictureHTML}</a>`
            : `<div class="${classesConteudo}">${pictureHTML}</div>`;

        const html = `
        <div class="banner-wrapper position-relative" data-banner-id="${banner.ID}">
            ${conteudoHTML}
        </div>`;

        container.innerHTML = html;

        //const botaoFecharElemento = container.querySelector('.btn-close');
        //if (botaoFecharElemento) {
        //    botaoFecharElemento.addEventListener('click', () => {
        //        this.ocultarBanner(banner.ID);
        //    });
        //}

        const linkElement = container.querySelector('a');
        if (linkElement) {
            linkElement.style.transition = 'opacity 0.3s ease-in-out';

            linkElement.addEventListener('mouseover', () => {
                linkElement.style.opacity = '0.8';
            });

            linkElement.addEventListener('mouseout', () => {
                linkElement.style.opacity = '1';
            });
        }
    },

};

